<template>
	<div class="modal fade" id="modal-alamat-map" role="dialog" data-backdrop="static">
		<div class="modal-dialog modal-lg bani-modal h-100">
			<div class="modal-content w-limit vh-100" style="border-radius: 0">
				<div class="modal-header" v-if="!isSearchMap">
					<div class="nav-btn kiri tutup">
						<img src="@/assets/img/x2.svg" @click="back" alt="">
					</div>
					<h5 class="navbar-title text-center">Titik Lokasi</h5>
					<div class="nav-btn kanan">
						<img src="@/assets/icons/search.svg" @click="() => { isSearchMap = !isSearchMap }" alt=""/>
					</div>
				</div>

				<div class="fixed-top bg-white w-limit" v-if="isSearchMap">
					<div class="d-flex justify-content-between align-items-center p-x-20 p-y-12 border-bottom">
						<input type="text" class="w-100 f-16"
						       style="border: none; outline: none"
						       placeholder="Cari..."
						       id="search-map"
						       v-model="search"
						       autofocus
						       autocomplete="off"
						       @keyup="typing"
						>
						<img src="@/assets/icons/closeblue.svg" @click="() => { isSearchMap = !isSearchMap }"/>
					</div>
					<div class="p-x-20 p-y-12 d-flex-between-center align-items-start border-bottom"
					     v-for="item in items"
					     @click="setLatLng(item)"
					>
						<i class="fa fa-map-marker f-c-midgrey m-r-10"></i>
						<div class="d-block w-100 p-r-20">
							<div class="f-semi f-16 f-c-black">{{ item.address.name }}</div>
							<div class="f-regular f-13 f-c-midgrey nomore">{{ item.address.full }}</div>
						</div>
					</div>
				</div>

				<div class="w-limit flex-100" id="main-maps">
					<div class="flex-1" style="position: relative">
						<GmapMap
							:center="mapCenter"
							:zoom="marker.defaultOptions.zoom"
							:options="{ streetViewControl: false, disableDefaultUI: true }"
							ref="map"
							@center_changed="updateCoordinates"
							@idle="sync"
							class="map-container">
							<!--<GmapCircle-->
							<!--	ref="circleRef"-->
							<!--	:center=marker.location-->
							<!--	:radius="marker.defaultOptions.radius"-->
							<!--	:visible="true"-->
							<!--	:options="{-->
							<!--        fillColor: '#206CFF',-->
							<!--        fillOpacity:0.2,-->
							<!--           strokeWeight: 1,-->
							<!--           strokeColor: '#206CFF',-->
							<!--           strokeOpacity: 0.5,-->
							<!--    }"-->
							<!--/>-->
							<GmapMarker
								:position="marker.location"
								:icon="iconConfig"
							/>
						</GmapMap>
					</div>
					<div class="background-white">
						<div class="p-x-20 p-y-12">
							<div class="f-regular f-16 f-c-black nomore">{{ marker.address.name }}</div>
							<div class="f-regular f-13 f-c-midgrey">
								{{ marker.address.full }}
							</div>
							<div class="d-flex-between-center m-t-12">
								<button class="btn btn-outline-danger btn-long m-r-10" @click="deleteLatLng">Hapus
								</button>
								<button class="btn btn-primary btn-long" @click="saveLatLng">Simpan</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import {mapGetters} from "vuex";

export default {
	name: "SOCustomerCreateAlamatMap",
	components: {
		SOTitleBar
	},
	computed: {
		...mapGetters("customerModule", {
			alamatTemp: "getAlamatTemp"
		})
	},
	props: {
		isCreate: Boolean,
		isEdit: Boolean,
	},
	data() {
		return {
			isSearchMap: false,

			// map
			mapCenter: null,
			marker: {
				pinned: false,
				location: {
					lat: -6.175253729974098,
					lng: 106.82713133905226
				},
				address: {
					name: "",
					full: "",
				},
				defaultOptions: {
					zoom: 20,
					radius: 5,
				}
			},
			iconConfig: {
				url: require('@/assets/icons/marker-blue.svg'),
				size: {
					width: 28,
					height: 28,
					f: "px",
					b: "px"
				},
				scaledSize: {
					width: 28,
					height: 28,
					f: "px",
					b: "px"
				}
			},

			// search
			search: "",
			timer: null,
			items: [],

			pageSetting: {
				pageType: {
					default: true,
					create: false,
					edit: false,
				},
			},
		}
	},
	mounted() {
		$("#modal-alamat-map").modal("show")

		if (this.isCreate) {
			this.alamatTemp.idcustomer = this.$route.params.idcustomer
			this.pageSetting.pageType.default = false
			this.pageSetting.pageType.create = true
			this.pageSetting.pageType.edit = false
		} else if (this.isEdit) {
			this.pageSetting.pageType.default = false
			this.pageSetting.pageType.create = false
			this.pageSetting.pageType.edit = true
		} else {
			this.pageSetting.pageType.default = true
			this.pageSetting.pageType.create = false
			this.pageSetting.pageType.edit = false
		}

		if (this.alamatTemp.longitude !== 0 && this.alamatTemp.latitude !== 0) {
			this.marker.location.lat = this.alamatTemp.latitude
			this.marker.location.lng = this.alamatTemp.longitude
		}
		this.reverseGeocode(this.marker.location.lat, this.marker.location.lng)
	},
	created() {
		this.sync()
	},
	methods: {
		back() {
			// if (this.pageSetting.pageType.edit) {
			// 	this.$router.push("/konsumen/alamat/edit/" + this.alamatTemp.idcustomer + "/" + this.alamatTemp.idalamat)
			// 	return
			// }
			// if (this.pageSetting.pageType.create) {
			// 	this.$router.push("/konsumen/alamat/create/" + this.alamatTemp.idcustomer)
			// 	return
			// }
			// this.$router.push("/konsumen/create/alamat")

			$("#modal-alamat-map").modal("hide")
			setTimeout(() => {
				this.$emit("close")
			})
		},

		// map
		updateCoordinates(latLng) {
			this.marker.location = {lat: latLng.lat(), lng: latLng.lng()}
			if (!this.awaitingDrag) {
				setTimeout(() => {
					this.reverseGeocode(latLng.lat(), latLng.lng())
					this.awaitingDrag = false;
				}, 2000); // 1 sec delay
			}
			this.awaitingDrag = true;
		},
		sync() {
			this.mapCenter = this.marker.location
		},
		setMapContainer() {
			setTimeout(() => {
				var sticky = $(".background-white").height();
				var modalHeader = $(".modal-header").outerHeight();
				$(".map-container").css({"max-height": "calc(100vh - " + (sticky + modalHeader) + "px)"})
			}, 100)
		},
		async reverseGeocode(lat, lng) {
			try {
				const res = await this.$axios.get("https://maps.googleapis.com/maps/api/geocode/json?" +
					"latlng=" + lat + "," + lng +
					"&key=" + this.$gmapKey
				)
				this.marker.address = {
					name: res.data.results[0].formatted_address,
					full: res.data.results[0].formatted_address
				}
				this.setMapContainer()
			} catch (e) {
				this.$catch_error_response(e)
			}
		},

		// search
		typing() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
				if (this.search === "") {
					this.items = []
					return
				}
				this.locationSearch()
			}, 500);
		},
		async locationSearch() {
			try {
				this.items = [];
				const res = await this.$axios.get(this.$baseurl + "masterData/meta/search_lokasi_maps?key_place=" + encodeURI(this.search),  this.requestHeaders)
				if (res.status) {
					for (var i = 0; i < res.data.data.results.length; i++) {
						this.items.push({
							latlng: {
								lat: res.data.data.results[i].geometry.location.lat,
								lng: res.data.data.results[i].geometry.location.lng,
							},
							address: {
								name: res.data.data.results[i].name,
								full: res.data.data.results[i].formatted_address
							},
						})
						if (i === 2) {
							break;
						}
					}
				}
			} catch (e) {
				this.$catch_error_response(e)
			}
		},
		setLatLng(mapInfo) {
			this.marker.location = mapInfo.latlng
			this.marker.address = mapInfo.address
			this.mapCenter = this.marker.location
			this.marker.pinned = true

			this.isSearchMap = false

			this.setMapContainer()
		},
		saveLatLng() {
			let payload = this.alamatTemp
			payload.latitude = this.marker.location.lat
			payload.longitude = this.marker.location.lng
			payload.alamat_gmaps = this.marker.address.full
			payload.alamat = (payload.alamat !== '') ? payload.alamat : this.marker.address.full
			this.$store.commit("customerModule/setAlamatTemp", payload)
			this.back()
		},
		deleteLatLng() {
			let payload = this.alamatTemp
			payload.latitude = 0
			payload.longitude = 0
			payload.alamat = (payload.alamat === payload.alamat_gmaps) ? "" : payload.alamat
			payload.alamat_gmaps = ""
			this.$store.commit("customerModule/setAlamatTemp", payload)
			this.back()
		}
	},
}
</script>

<style scoped>
.map-container {
	height: 100vh;
	width: 100%;
}
</style>